import * as actionTypes from "../actions/actionTypes";

// Single-slot print buffer: holds the ONE payload for the print view currently
// being opened, tagged with its printKey. Set immediately before navigation, so
// large payloads never travel through react-router's location.state (which
// silently fails past the browser's history.pushState size limit). Each new
// print overwrites the slot; consumers compare `key` and ignore a mismatch
// (e.g. after a reload, where the slot is empty), falling back to NoPrintData.
const initialState = {
    key: null,
    payload: null,
};

const printingReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_PRINT_DATA:
            return { key: action.printKey, payload: action.payload };
        case actionTypes.CLEAR_PRINT_DATA:
            return initialState;
        default:
            return state;
    }
};

export default printingReducer;
